<div class="ap-wrap">
	<div class="imgmap-frontend-image">
		<div class="home-imagemap-head-bg"></div>
    <div style="display: block; position: relative;">
      <img
        [src]="buildingFloor.map_plan.url"
        usemap="#ap-map"
        id="ap-img"
        class="ap-img"
        loading="lazy"
      >
    </div>
		<map name="ap-map">
      <area
				*ngFor="let property of buildingFloor.properties, trackBy: listTrackingService.disableUpdate"
        data-type="link"
        [href]="property.availability == 'available' ? (basePath == '/' ? '' : basePath) + '/apartamente/' + property.friendly_id : currentRoute()"
        [attr.data-tooltip]="propertyToolTip(property)"
        data-fill-color="E4BD62"
        data-fill-opacity="0.5"
        data-stroke-color="fefefe"
        data-stroke-opacity="0.8"
        data-stroke-width="2"
        [attr.data-mapkey]="'area-' + property.friendly_id"
        shape="poly"
        [attr.coords]="property.area.join(',')"
				[class.selected]="property.availability != 'available'"
      >
		</map>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/map-plan/map-plan-building-floor-base.component.html